import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonClass } from 'src/app/common';
import { ApiService } from 'src/app/services/api.service';
import { InterestMasterService } from 'src/app/services/interest-master.service';
import { NatureOfBusinessMasterService } from 'src/app/services/nature-of-business-master.service';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-provisionally-terminated-list',
  templateUrl: './provisionally-terminated-list.component.html',
  styleUrls: ['./provisionally-terminated-list.component.scss']
})
export class ProvisionallyTerminatedListComponent implements OnInit {
  localStorage: any;
  terminatedlist: any[] = [];
  slug: any;
  storageData: any;
  colFilter = [
    { field: 'S. No.' },
    { field: 'action' },
    { field: 'payment' },
    { field: 'status' },
    { field: 'company_name' },
    { field: 'member_since' },
    { field: 'membership_no' },
    { field: 'email' },
    { field: 'date' },
    { field: 'renewal_status' },
    { field: 'invoice' },
    { field: 'checklist' },
    { field: 'letter' },
    { field: 'notesheet' },
  ];
  status = [
    { label: 'Verified', value: 'Verified' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Approved', value: 'approved' },
    { label: 'In Progress', value: 'in progress' },
    { label: 'Terminated', value: 'Terminated' },
    { label: 'Provisionally Terminated', value: 'Provisionally Terminated' },
  ];
  breadcrumb: any[];
  loading: boolean = false;
  filterVal: any;
  tooltipText: any;
  company_name: string;
  email:string
statusFilter: any = null;
VerificationDialog:boolean =false;
verificationdata: any;
  userNames: any[];
  userNameMap: {};
  memberId: any;
  verficationStatus: any;
  memberVerficationDetails: any;
  memberDetails: any[];
  statusandremark: any;
  userId: any;
  document_status: string;
  userVerified: any;
  hwmMemberList: any;
TerminationDialog:boolean=false
  selectedMember: any;
  constructor(
    private commonFunction: CommonClass,
    private __apiservice: ApiService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private paymentservice: PaymentService,
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public interestMasterService: InterestMasterService,
    private natureofBusiness: NatureOfBusinessMasterService,
    private activated: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.localStorage = this.commonFunction.getLocalStorage();
    this.storageData = JSON.parse(localStorage.getItem('access_token'));
    this.spinner.show();
    this.slug = this.activated.snapshot.params;

    this.getTerminateMember();

    if ((this.localStorage.role == 'Admin') || (this.localStorage.role == 'UCCI Staff') || (this.localStorage.role == 'President')) {
      this.colFilter = [
        { field: 'S. No.' },
        { field: 'action' },
        { field: 'status' },
        { field: 'company_name' },
        { field: 'email' },
      ];

    }
  }

  getTerminateMember() {
  const id =0;
    this.apiService.terminateHWM(id).subscribe(
      (res: any) => {
        this.terminatedlist = res.data;
        console.log(this.terminatedlist);

      }
    )
  }
  reset(dt) {
   this.filterVal=''
   this.company_name=''
   this.email=''
  this.statusFilter = null; // reset dropdown value
   dt.clear()
  }
 approveMemberById(id?: any, status?: any,string?:any) {
  this.confirmationService.confirm({
    message: 'Are you sure you want to proceed?',
    header: 'Confirmation',
    icon: 'pi pi-info-circle',
    accept: () => {
      console.log(id, status);
      const payload = {
        id: id,
        status: string
      };

      this.apiService.provisionalterminate(id,payload).then(
        (response) => {
          this.messageService.add({
            severity: 'success',
            detail: response.message,
          });
          this.getTerminateMember()
        },
        (error) => {
          this.messageService.add({
            severity: 'error',
            detail: error.message,
          });
          console.error('Upload failed', error);
        }
      );
    },
    reject: () => {
      this.messageService.add({
        severity: 'info',
        detail: 'Operation cancelled',
      });
    }
  });
}
 terminationstring:any
  selectedMemberId: any;
  terminatted(member_id?: any, value?: any, string?:any, memberdetail?: any) {
      console.log(this.terminationstring);
       this.selectedMember = memberdetail;
       console.log(this.selectedMember);
       
      this.selectedMemberId= member_id
     const userid =this.localStorage.userId
        this.TerminationDialog=true
       console.log(userid);
        console.log(value);
      let status = '';
   

}
verificationFormFunction() {
  const userid = this.localStorage.userId;
  const remark = this.verificationForm.value.remark;
  const verification = this.selectedMember.terminate_verification;

  // Determine which slot to fill (1 → 2 → 3)
  let payload: any = {
    member_id: this.selectedMemberId,
    status: 'partially terminated',
  };

  if (!verification.tvid_1) {
    payload.tvid_1 = userid;
    payload.tvremarks_1 = remark;
    payload.tverification1 = 1;
  } else if (!verification.tvid_2) {
    payload.tvid_2 = userid;
    payload.tvremarks_2 = remark;
    payload.tverification2 = 1;
  } else if (!verification.tvid_3) {
    payload.tvid_3 = userid;
    payload.tvremarks_3 = remark;
    payload.tverification3 = 1;
  } else {
    this.messageService.add({
      severity: 'warn',
      detail: 'All verification slots are already filled.',
    });
    return;
  }

  // Call the API
  this.apiService.terminatedHwm(payload).subscribe(
    (res: any) => {
      this.messageService.add({
        severity: 'success',
        detail: res?.message || 'Status updated successfully.',
      });
      this.TerminationDialog = false; // close dialog
    },
    (error) => {
      this.messageService.add({
        severity: 'error',
        detail: error.message || 'Error updating status.',
      });
    }
  );
}

  verificationForm = new FormGroup({ remark: new FormControl('', [Validators.required]) });
}
// approveMemberById(value?: any, id?: any, boolean?: any, memberData?: any, status?: any) {
//     this.userNames = [];
//   this.userNameMap = {}; 
//     this.memberId = id;
//     this.verficationStatus = status;
//     console.log(memberData);
//     console.log(status,"checked");
    
//     this.memberVerficationDetails = memberData.hwm_verification_details?.[0];
// try {
//   const remarkStr = this.memberVerficationDetails?.status_and_remark;

//   if (remarkStr && typeof remarkStr === 'string') {
//     this.verificationdata = JSON.parse(remarkStr);
//     console.log(this.verificationdata, 'data');
//   } else {
//     console.warn('Invalid or empty status_and_remark:', remarkStr);
//     this.verificationdata = [];
//   }
// } catch (err) {
//   console.error('JSON parse error:', err);
//   this.verificationdata = [];
// }

    
//     if (memberData?.hwm_verification_details?.length !== 0) {
//         const promises = [];
//         for (let i = 1; i <= 3; i++) {
//             const vidKey = 'vid_' + i;
//             const vid = memberData?.hwm_verification_details?.[0]?.[vidKey];
//              console.log(vid);
             
//             // Check if vid is not null
//             if (vid !== null) {
//                 // Call getUserbyId and push the result into userNames array
//                 promises.push(
//                     new Promise((resolve, reject) => {
//                         this.apiService.getUserbyId(vid).subscribe(
//                             (res: any) => {
//                                 resolve(res?.name);
//                             },
//                             error => {
//                                 reject(error);
//                             }
//                         );
//                     })
//                 );
//             }
//         }
//   const uniqueVids = new Set<string>();
//   const steps = [1, 2, 3];
//   for (const record of this.verificationdata) {
//     for (const step of steps) {
//       const vid = record[`vid_${step}`];
//       if (vid) {
//         uniqueVids.add(vid);
//       }
//     }
//   }
//   const username = Array.from(uniqueVids).map(vid =>
//     new Promise((resolve, reject) => {
//       this.apiService.getUserbyId(vid).subscribe(
//         (res: any) => {
//           if (res?.id == vid || res?.member_id == vid) {
//             this.userNameMap[vid] = res.name;
//           }
//           resolve(true);
//         },
//         error => reject(error)
//       );
//     })
//   );
//         Promise.all(promises)
//             .then(names => {
//                 this.userNames.push(...names.filter(name => name)); // Push only non-null names
                
//                 console.log(this.userNames); // Log user names here if needed

//                 // Perform further actions here
//                 // if (value == 'hwm') {
//                 //     // Your logic for hwm approval/rejection
//                 // } else if (value == 'verification') {
//                     this.memberDetails = [];
//                     this.VerificationDialog = true;
//                     if (memberData?.hwm_verification_details?.length > 0) {
//                         memberData?.hwm_verification_details?.forEach(res => {
//                             this.statusandremark = res.status_and_remark;
//                             this.memberDetails = JSON.parse(JSON.parse(res.status_and_remark));
//                         });
//                     }
//                 // }
//             })
//             .catch(error => {
//                 console.error('Error fetching user names:', error);
//             });
//     } else {
//         console.log(this.userNames); // Log user names here if needed

//         // Perform further actions here
//         // if (value == 'hwm') {
           
//         // } else if (value == 'verification') {
//             this.memberDetails = [];
//             this.VerificationDialog = true;
//             if (memberData.hwm_verification_details.length > 0) {
//                 memberData.hwm_verification_details.forEach(res => {
//                     this.statusandremark = res.status_and_remark;
//                     this.memberDetails = JSON.parse(JSON.parse(res.status_and_remark));
//                 });
//             }
//         // }
//     }
// }
//   data: any;
//   verificationForm = new FormGroup({ remark: new FormControl('', [Validators.required]) });
//   verificationFormFunction(hwmverification) {


//     if (localStorage.getItem('access_token')) {
//       var userName: any = JSON.parse(localStorage.getItem('access_token')).username;
//       this.userId = JSON.parse(localStorage.getItem('access_token')).userId;
//       console.log(this.userId);
      
//     }
//     if (this.verificationForm.valid) {
//       let formData = new FormData();
//       this.data = this.verificationForm.value;
//       if (this.document_status == 'Verified') {
//         if(this.verficationStatus == 'Provisionally Terminated'){
//           formData.append('vid_1',this.userId);
//           formData.append('verification1','1');
//           formData.append('vremarks_1',this.verificationForm.value.remark);
//         }
//         else if (this.memberVerficationDetails?.vid_1 == this.userId) {
//     // User is modifying their own first verification decision
//     formData.append('vid_1', this.userId);
//     formData.append('verification1', this.document_status == 'Verified' ? '1' : '0');
//     formData.append('vremarks_1', this.verificationForm.value.remark);
// }else if(this.memberVerficationDetails?.verification2 == null && this.memberVerficationDetails?.verification1 == 1){
//           formData.append('vid_2',this.userId);
//           formData.append('verification2','1');
//           formData.append('vremarks_2',this.verificationForm.value.remark);
//         }
//           else if (this.memberVerficationDetails?.vid_2 == this.userId) {
//     // User is modifying their own first verification decision
//     formData.append('vid_2', this.userId);
//     formData.append('verification2', this.document_status == 'Verified' ? '1' : '0');
//     formData.append('vremarks_2', this.verificationForm.value.remark);
// }
//         else if(this.memberVerficationDetails?.verification3 == null && this.memberVerficationDetails?.verification2 == 1){
//           formData.append('vid_3',this.userId);
//           formData.append('verification3','1');
//           formData.append('vremarks_3',this.verificationForm.value.remark);
//         }
//       } else if (this.document_status == 'Discrepancy') {
//         // const DetailsData = [
//         //   {
//         //     status: this.document_status,
//         //     remark: this.verificationForm.value.remark,
//         //     user_id: this.userId,
//         //     staff_name: userName,
//         //   }
//         // ];
//         // const combinedData = [
//         //   ...DetailsData,
//         //   ...this.memberDetails
//         // ];
//         // const hwm_verification_json = JSON.stringify(combinedData);
//         // formData.append('remark', this.data?.remark);
//         // formData.append('status', this.document_status);
//         // formData.append('hwm_verification_json', hwm_verification_json);
//         if(this.verficationStatus == 'In Progress' && this.memberVerficationDetails == null){
//           formData.append('vid_1',this.userId);
//           formData.append('verification1','0');
//           formData.append('vremarks_1',this.verificationForm.value.remark);
//         }else if(this.memberVerficationDetails?.verification2 == null && this.memberVerficationDetails?.verification1 == 1){
//           formData.append('vid_2',this.userId);
//           formData.append('verification2','0');
//           formData.append('vremarks_2',this.verificationForm.value.remark);
//         }else if(this.memberVerficationDetails?.verification3 == null && this.memberVerficationDetails?.verification2 == 1){
//           formData.append('vid_3',this.userId);
//           formData.append('verification3','0');
//           formData.append('vremarks_3',this.verificationForm.value.remark);
//         }
//       }
//       debugger
//        console.log(formData);
       

//       this.apiService.verifyHwmProcess(this.memberId, formData)
//         .subscribe((res: any) => {
//           if (res?.code == 200) {
//             hwmverification.resetForm();
//             this.messageService.add({
//               severity: 'success',
//               detail: res.message,
//             });
//             setTimeout(() => {
//               this.VerificationDialog = false;
//               hwmverification.resetForm();
//             }, 1000);

//             if(this.memberVerficationDetails?.verification1 == 1 && this.memberVerficationDetails?.verification2 == 1){
//               let body: any = {
//                 approval: 3,
//               };
//               this.__apiservice
//               .hwmMemberApproval(this.memberId, body)
//               .subscribe((res: any) => {
//                 console.log("member is verified");
//                 this.getHwmMemberList();
//               });
//             }
//             else{
//               this.getHwmMemberList();
//             }
            
//           }
//         });



//       this.userVerified = this.hwmMemberList.filter((event) => {
//         return this.memberId == event.id
//       })
//       console.log(this.userVerified);
//       // if (this.userVerified.length > 0) {
//       //   const verified = this.userVerified[0].hwm_verification_details[0].status_and_remark;
//       //   const jsonString = verified.slice(1, -1);
//       //   const validJSONString = jsonString.replace(/\\"/g, '"');

//       //   const jsonObject = JSON.parse(validJSONString);

//       //   console.log(jsonObject);
//       //   if(jsonObject.length == 2 ){
//       //     let body: any = {
//       //       approval: 3,
//       //     };
//       //     this.__apiservice
//       //     .hwmMemberApproval(this.memberId, body)
//       //     .subscribe((res: any) => {
//       //       console.log("member is verified");
//       //     });
//       //   }
//       // }
//     }
//   }
//   getHwmMemberList() {
//     throw new Error('Method not implemented.');
//   }
